import { Box, Typography, Paper } from "@mui/material";


export default function ResumenFacturacionTable({ data }) {

  if (!data)
    return (
      <Typography color="white" p={2}>
        Cargando resumen...
      </Typography>
    );

  const boxStyle = {
    bgcolor: "#2a2a2a",
    color: "white",
    p: 2,
    borderRadius: 2,
    textAlign: "center",
    boxShadow: "5px 10px 15px rgba(0,0,0,0.8)",
    width: "100%",
  };

  return (
    <Box
      px={1}
      pt={1}
      color="white"
      bgcolor="#171717"
      display="flex"
      flexDirection="column"
      width="90%"
      height="86%"
      borderRadius={2}
    >
      <Typography variant="h6" fontWeight="bold" mb={2}>
        Facturación del Día
      </Typography>

      <Box height="50%" display="flex" gap={4}>
        <Paper sx={boxStyle}>
          <Typography variant="subtitle1">Caja</Typography>
          <Typography variant="h6">${data.caja}</Typography>
        </Paper>
        <Paper sx={boxStyle}>
          <Typography variant="subtitle1">Cuenta</Typography>
          <Typography variant="h6">${data.cuenta}</Typography>
        </Paper>
        <Paper sx={boxStyle}>
          <Typography variant="subtitle1">Total</Typography>
          <Typography variant="h6">${data.total}</Typography>
        </Paper>
      </Box>
    </Box>
  );
}
